import { useGlobalSearchParams } from "expo-router";
import ShiftIncidentScreen from "@/components/screens/ShiftIncidentScreen";

export default function IncidentPage() {
  const { shift } = useGlobalSearchParams<{ shift?: string }>();

  if (!shift) return null;

  return <ShiftIncidentScreen shiftId={shift} />;
}
